import { Box, styled, Tab, Tabs } from '@mui/material';
import { TabPanel } from '@mui/lab';

export const StyledTab = styled(Tab)(({ theme }) => ({
  borderRadius: '8px',
  fontWeight: 700,
  fontSize: theme.typography.button.fontSize,
  marginLeft: theme.spacing(1),
  padding: '6px 12px',
  minHeight: 'auto',
  minWidth: 'auto',
  color: theme.palette.text.primary,
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  '&.Mui-focusVisible': {
    backgroundColor: theme.palette.primary.main,
  },
  ':hover': {
    backgroundColor: '#f5f5f5',
  },
}));

export const StyledTabPanel = styled(TabPanel)<{ floatingmode?: string }>`
  padding: 0;
  max-height: ${(props) => (props.floatingmode === 'true' ? '50vh' : '100vh')};
  overflow-y: auto;
`;

export const OptionsContainer = styled(Box)<{
  floatingmode?: string;
  dialogmode?: string;
}>`
  box-shadow: ${(prop) =>
    prop.floatingmode === 'true' &&
    '0 1px 3px rgb(60 63 66 / 32%), 0 4px 12px rgb(60 63 66 / 15%)'};

  border-radius: ${(prop) => prop.dialogmode !== 'true' && '0 0 16px 16px'};

  background: #fff;
  padding-bottom: 30px;
  overflow: hidden;
`;

export const ContainerOptions = styled(Box)<{
  dialogmode?: string;
}>`
  z-index: 1000;
  box-shadow: ${(prop) =>
    prop.dialogmode !== 'true' &&
    '0 1px 3px rgb(60 63 66 / 32%), 0 4px 12px rgb(60 63 66 / 15%)'};

  border-radius: ${(prop) => prop.dialogmode !== 'true' && '0 0 12px 12px'};
  position: ${(prop) => prop.dialogmode !== 'true' && 'absolute'};
  background: #fff;
  overflow: hidden;
  width: 100%;
`;
